module.exports = __webpack_public_path__ + "img/jingyingbang-vip.d1eeaae4.png";